// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"297":"ef8f927c","374":"932d95f3","805":"ef8f927c"}[chunkId] + ".chunk.css";
};